import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { ThemeContext, LanguageContext, UserContext, ActionContext } from "../contexts/Context";
import axios from "axios";
import { navigate } from "@reach/router"
import { IoCloseOutline, IoLogoInstagram } from "react-icons/io5";
import Modal from '../newcomponents/optioncomponents/Modal';
import CusPdpa from '../newcomponents/customerComponents/CustomerPdpa';
import CusRegister from "../newcomponents/customerComponents/CustomerRegister2";
import CusPass from '../newcomponents/customerComponents/CustomerPassword';
import CusForgot from '../newcomponents/customerComponents/CustomerForgot';
import { getRecentBought } from "../newcomponents/customerComponents/CustomerRecentAPI";
import {
    getAssetUrl,
    getCompanyAddress,
    getCompanyPhone,
    getInstagramInfo,
    getOperatingHours
} from "../newcomponents/customerComponents/loginDisplayUtil";

const CustomerLogin = ({ token }) => {

    const themeContext = React.useContext(ThemeContext);
    const languageContext = React.useContext(LanguageContext);
    const { registerUserData, addCustomer, setRecentItem } = React.useContext(ActionContext);
    const {
        lanIndex, userId, company, recentBought, bgImg, landingImg, otherUrls,
        openingTime, closingTime
    } = React.useContext(UserContext);
    const [phone, setPhone] = useState("");
    const [pin, setPin] = useState("");
    const [warningMsg, setWarningMsg] = useState("");
    const [error, setError] = useState([]);
    const [showError, setShowError] = useState(false);
    const [showPdpa, setShowPdpa] = useState(false);
    const [showPass, setShowPass] = useState(false);
    const [showRegister, setShowRegister] = useState(false);
    const [showForgot, setShowForgot] = useState(false);
    const [processing, setProcessing] = useState(false);


    useEffect(() => {
        let currentDate = new Date().getTime();
        const makeid = (length) => {
            var result = [];
            var characters =
                "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            var charactersLength = characters.length;
            for (var i = 0; i < length; i++) {
                result.push(
                    characters.charAt(Math.floor(Math.random() * charactersLength))
                );
            }
            return result.join("");
        };

        const generateUserId = () => {
            let currentDate = new Date().getTime();
            return makeid(20) + currentDate;
        };

        registerUserData(token, generateUserId(), currentDate);

    }, [registerUserData, token]);

    const submitPassword = (password) => {
  
        if (password == "") {
            setError([{ errorMessage: "Password cannot be empty" }]);
            return;
        }

        if (processing) return;
        setProcessing(true);
        if (token) {
            axios.post(`/v2/api/customer/login`,
                {
                    phone: phone,
                    password: password
                },
                { headers: { Authorization: "Bearer " + token } })
                .then(function (response) {
                    setProcessing(false);
                    if (response.status == 200) {
                        addCustomer(response.data);
                        navigate('/member/info');
                        if (recentBought) {
                            getRecentBought(phone, token).then(res => {
                                setRecentItem(res);
                            })
                        }
                    }

                })
                .catch(function (error) {
                    //show warning
                    setProcessing(false);
                    if (error.response && error.response.status == 401) {
                        setError([{ errorMessage: "Invalid phone no or password" }]);
                        setShowError(true);
                    } else {
                        setError([{ errorMessage: "Something went wrong. Please try again" }]);
                        setShowError(true);
                    }
                })


        }

    }

    const submitRegister = (customer) => {
        if (processing) return;
        if (token && userId) {
            setProcessing(true);
            axios.post(`/v2/api/customer`,
                customer,
                {
                    headers: { Authorization: "Bearer " + token },
                })
                .then(function (response) {
                    setProcessing(false);
                    if (response.status == 200) {
                        setShowRegister(false);
                        addCustomer(response.data.customer);
                        navigate('/member/info');
                    }

                })
                .catch(function (error) {
                    //show warning
                    setProcessing(false);
                    if (error.response && error.response.status == 402) {
                        
                        setError([{ errorMessage: "Phone No has been used" }]);
                        setShowError(true);
                    } else {
                        
                        setError([{ errorMessage: "Something went wrong. Please try again" }]);
                        setShowError(true);
                    }
                })
        }
    };

    const memberSubmit = () => {
        if (phone == "") {
            setWarningMsg("Phone No is required");
            return;

        }
        if (pin) {
            submitPassword(pin);
            return;
        }
        if (processing) return;
        setProcessing(true);
        if (token && userId) {
            axios.post(`/v2/api/customer/check`,
                {
                    phone: phone
                },
                {
                    headers: { Authorization: "Bearer " + token },
                })
                .then(function (response) {
                    setProcessing(false);
                   
                    if (response.status == 200) {
                        //check if user already register
                        if (response.data.status == 0) {//not register yet
                            setWarningMsg("Incorrect phone no");
                        } else if (response.data.status == 1) {
                            addCustomer(response.data.customer);
                            register();
                        } else if (response.data.status == 2) { //has data, need password
                            setShowPass(true);
                        } else { //go direct to member page
                            addCustomer(response.data.customer);
                            navigate('/member/info');
                        }

                    }

                })
                .catch(function (error) {
                    //show warning
                 
                    setProcessing(false);
                    if (error.response && error.response.status == 401) {
                        setError([{ errorMessage: "Invalid phone no or password" }]);
                        setShowError(true);
                    } else {
                        setError([{ errorMessage: "Something went wrong. Please try again" }]);
                        setShowError(true);
                    }
                })


        }
    }



    const register = (e) => {
        setShowRegister(true);
    }
    const forgotPwd = () => {
        setShowForgot(true);
    }
    const handleChange = (e, name) => {
        if (name == 'phone') {
            setPhone(e);
        } else {
            setPin(e);
        }
        setWarningMsg("");
    }

    const operatingHours = getOperatingHours(openingTime, closingTime);
    const companyAddress = getCompanyAddress(company);
    const companyPhone = getCompanyPhone(company);
    const instagramInfo = getInstagramInfo(otherUrls);
    const isMemberLoginUrl = typeof window !== "undefined" && window.location.pathname.startsWith("/member/login");

   
    return (
        //phone, name, email, dob, gender password
        <React.Fragment>
            <ModalContainer bgImg={bgImg} themeContext={themeContext} >
                <ContentWrapper>
                    <FormSection>
                        <ImgWrapper image={company && company.companyLogo} />
                        <TitleText>SIGN IN</TitleText>
                        <WarningMsg themeContext={themeContext}>
                            {warningMsg}
                        </WarningMsg>
                        <Input
                            value={phone}
                            onChange={(e) => { handleChange(e.target.value, 'phone') }}
                            placeholder={`${languageContext[lanIndex].phone}*`}
                            type="tel"
                            aria-label={languageContext[lanIndex].phone}
                        />
                        <Input
                            type="password"
                            value={pin}
                            onChange={(e) => { handleChange(e.target.value, 'pin') }}
                            placeholder="Password*"
                            aria-label="Password"
                        />
                        <ForgotButton onClick={forgotPwd}>
                            Forgot your password?
                        </ForgotButton>
                        <LoginButton onClick={memberSubmit} >
                            SIGN IN
                        </LoginButton>
                        <RegisterButton onClick={register}>
                            CREATE A NEW ACCOUNT
                        </RegisterButton>
                    </FormSection>
                    {(landingImg || operatingHours || companyPhone || companyAddress || instagramInfo) &&
                        <FooterInfo>
                            {landingImg && <FooterLandingImage image={landingImg} />}
                            {operatingHours && <FooterLine>{operatingHours}</FooterLine>}
                            {companyPhone && <FooterLine>{companyPhone}</FooterLine>}
                            {companyAddress && <FooterAddress>{companyAddress}</FooterAddress>}
                            {instagramInfo && instagramInfo.url &&
                                <InstagramLink href={instagramInfo.url} target="_blank" rel="noopener noreferrer">
                                    <IoLogoInstagram size={46} />
                                    {instagramInfo.handle && <InstagramHandle>{instagramInfo.handle.split("?")[0]}</InstagramHandle>}
                                </InstagramLink>
                            }
                        </FooterInfo>
                    }
                </ContentWrapper>

            </ModalContainer>
            <Modal
                show={showError}
                setShow={setShowError}
                error={error}
                fontFamily={'"contralto-xsmall", sans-serif'}
            />
            <CusRegister
                show={showRegister}
                setShow={setShowRegister}
                setShowError={setShowError}
                setError={setError}
                onSubmit={submitRegister}
                setShowPdpa={setShowPdpa} />
            <CusPdpa
                show={showPdpa}
                setShow={setShowPdpa}
                setShowError={setShowError}
                setError={setError}
            />
            <CusPass
                show={showPass}
                setShow={setShowPass}
                setShowError={setShowError}
                setError={setError}
                handleCallback={submitPassword}
            />
            <CusForgot
                show={showForgot}
                setShow={setShowForgot}
                setShowError={setShowError}
                setError={setError}
            />
        </React.Fragment >
    );
}

export default CustomerLogin;

const WarningMsg = styled.div`
    min-height: 20px;
    margin: 6px 0 12px;
    color: ${(props) => props.themeContext.fontAlert};
`;

const LoginButton = styled.div`
    display: flex;
    width: 68%;
    max-width: 360px;
    min-height: 62px;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    font-weight: 400;
    border-radius: 34px;
    background-color: #5f5f5f;
    color: #ffffff;
    box-shadow: 0px 2px 5px rgba(0,0,0,0.18);
    cursor: pointer;

    @media (max-height: 760px) {
        min-height: 54px;
        font-size: 21px;
    }
`;

const ForgotButton = styled.div`
    align-self: flex-end;
    margin: -4px 8px 30px 0;
    font-size: 16px;
    color: #505050;
    cursor: pointer;
`;

const RegisterButton = styled.div`
    margin-top: 24px;
    font-family: "contralto-xsmall", sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #444444;
    text-decoration: underline;
    cursor: pointer;
`;
const ImgWrapper = styled.div`
    width: 220px;
    max-width: 78%;
    height: 220px;
    margin: 0 0 20px;
    background-image: ${(props) => props.image ? `url(${getAssetUrl(props.image)})` : "none"};
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    @media (max-height: 760px) {
        width: 180px;
        height: 120px;
        margin-bottom: 14px;
    }
`;

const Input = styled.input`
  width: 100%;
  min-height: 76px;
  border-radius: 12px;
  padding: 0 26px;
  font-size: 24px;
  border: 1px solid #9d9d9d;
  margin-bottom: 18px;
  background-color: rgba(255,255,255,0.94);
  color: #343434;
  box-sizing: border-box;
  outline: none;

  &::placeholder {
    color: #a9a9a9;
  }

  @media (max-height: 760px) {
    min-height: 62px;
    font-size: 20px;
    margin-bottom: 12px;
  }
`;

const IconButton = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 99;
  color: #555555;
  cursor: pointer;
`;

const TitleText = styled.div`
    font-family: "contralto-xsmall", sans-serif;
    color: #333333;
    font-size: 30px;
    font-weight: 300;
    line-height: 1;

    @media (max-height: 760px) {
        margin-bottom: 20px;
        font-size: 26px;
    }
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 100dvh;
    box-sizing: border-box;
    padding: 44px 32px 34px;
    overflow-y: auto;
    gap: 34px;

    @media (max-height: 760px) {
        padding-top: 28px;
        gap: 22px;
    }
`;

const FormSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 500px;
    padding-top: 16px;
`;

const FooterInfo = styled.div`
    width: 100%;
    max-width: 520px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #555555;
    text-align: center;
`;

const FooterLandingImage = styled.div`
    width: 80%;
    height: 100px;
    margin-top: 100px;
    background-image: ${(props) => props.image ? `url(${getAssetUrl(props.image)})` : "none"};
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    @media (max-height: 760px) {
        height: 72px;
    }
`;

const FooterLine = styled.div`
    margin-top: 6px;
    font-size: 21px;
    line-height: 1.15;
`;

const FooterAddress = styled.div`
    max-width: 430px;
    margin-top: 10px;
    font-size: 15px;
    font-style: italic;
    line-height: 1.25;
`;

const InstagramLink = styled.a`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    margin-top: 42px;
    color: #555555;
    text-decoration: none;

    @media (max-height: 760px) {
        margin-top: 24px;
    }
`;

const InstagramHandle = styled.div`
    font-family: "contralto-xsmall", sans-serif;
    font-size: 14px;
`;

const ModalContainer = styled.div`
    display: flex;
    font-family: "contralto-xsmall", sans-serif;
    background-color:${(props) => props.themeContext.backgroundColor};
    flex-direction: column;
    background-image: ${(props) => props.bgImg ? `url(${getAssetUrl(props.bgImg)})` : "none"};
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    top: 0;

    width: 100vw;
    max-width: 550px;
    height: 100dvh;
    z-index: 8;

    *, input, button, textarea, select {
        font-family: "contralto-xsmall", sans-serif !important;
    }

    animation: modalOrder .1s;
    animation-timing-function: ease-out;
    @keyframes modalOrder {
        0%  {
        transform: translateY(350px);
        opacity: 0;
        }
        
        100%  {
        transform: translateY(0px);
        opacity: 1;
        }
        
    }

  `;
